import Model from "../../Model.js";
import Scenario from "./Scenario.js";

/**
 * The ScenarioManager takes care of handling scenarios for
 * a given forecast template.
 *
 * @param {Scenario[]} [scenarios] - The collection of all scenarios of
 *   a forecast template, e.g., "best case" or "another pandemic"
 * @param {Scenario} [baselineScenario] - The default scenario for the
 *   forecast template. This is where all new prediction rules go by
 *   default until another scenario is selected
 */
export default class ScenarioManager extends Model {
	constructor({ scenarios = [], baselineScenario = new Scenario() } = {}) {
		super(...arguments);

		this._scenarios = scenarios;
		this._baselineScenario = baselineScenario;
	}

	getBaselineScenario() {
		return this._baselineScenario;
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(...arguments);

		data.scenarios = Scenario.materializeAll(data.scenarios, context);

		data.baselineScenario &&= Scenario.materialize(
			data.baselineScenario,
			context,
		);
	}
}
